import { render, staticRenderFns } from "./VorVerschiebung.vue?vue&type=template&id=74bf6ee7"
import script from "./VorVerschiebung.vue?vue&type=script&lang=js"
export * from "./VorVerschiebung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports